import React from 'react';
import TableDownArrowImage from "images/table-down_arrow.png";
import TableUpArrowImage from "images/table-up_arrow.png";

export const SortingCurricularSummary = (data, sortCol, sortDir, isClc) =>{
  data.sort((a, b) => {
    let comparison = 0;
    let fa, fb
    if(isClc){
      fa = a[sortCol].cognitive_competence_score_excel;
      fb = b[sortCol].cognitive_competence_score_excel;
    }else {
       fa = a[sortCol];
       fb = b[sortCol];
    }
    if (fa < fb) {
      comparison = -1;
  } else if (fa > fb) {
      comparison = 1;
  }
    return sortDir === 'asc' ? comparison : -comparison;
   
});
  return data
}

export const sortImage = (currentSortCol, sortCol, onSort) => {
  const handleSortAsc = () => onSort(sortCol, 'asc');
  const handleSortDesc = () => onSort(sortCol, 'desc');

  const handleTouchStartAsc = (event) => {
    handleSortAsc();
  }

  const handleTouchStartDesc = (event) => {
    handleSortDesc();
  }

  return (
    <span className="sort-arrows">
      <span className='sort-up-arrow filter-label-focus' onClick={handleSortDesc} onTouchStart={handleTouchStartDesc} tabIndex="0" onKeyPress={(event) => { if(event.key === 'Enter') handleSortDesc(); }}></span>
      <span className='sort-bottom-arrow filter-label-focus' onClick={handleSortAsc} onTouchStart={handleTouchStartAsc} tabIndex="0" onKeyPress={(event) => { if(event.key === 'Enter') handleSortAsc(); }}></span>
    </span>
  );
};
